/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li1_TextInputs */

const tr_onbilgi_s10_li1_text = /** @type {(inputs: Onbilgi_S10_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Platform iletişimi TLS 1.3 üzerinden HTTPS protokolü ile şifrelenmiş olarak yapılır; HTTP yönlendirmeleri otomatik olarak HTTPS'e zorlanır.`)
};

const en_onbilgi_s10_li1_text = /** @type {(inputs: Onbilgi_S10_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Platform communication is encrypted via the HTTPS protocol over TLS 1.3; HTTP redirects are automatically forced to HTTPS.`)
};

const de_onbilgi_s10_li1_text = /** @type {(inputs: Onbilgi_S10_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesamte Kommunikation der Plattform erfolgt verschlüsselt über das HTTPS-Protokoll auf Basis von TLS 1.3; HTTP-Weiterleitungen werden automatisch auf HTTPS erzwungen.`)
};

const ru_onbilgi_s10_li1_text = /** @type {(inputs: Onbilgi_S10_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь обмен данными Платформы осуществляется в зашифрованном виде по протоколу HTTPS поверх TLS 1.3; переадресация с HTTP автоматически принудительно направляется на HTTPS.`)
};

/**
* | output |
* | --- |
* | "All Platform communication is encrypted via the HTTPS protocol over TLS 1.3; HTTP redirects are automatically forced to HTTPS." |
*
* @param {Onbilgi_S10_Li1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li1_text = /** @type {((inputs?: Onbilgi_S10_Li1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li1_text(inputs)
	if (locale === "de") return de_onbilgi_s10_li1_text(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li1_text(inputs)
	return tr_onbilgi_s10_li1_text(inputs)
});